const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Ids taken from the URL are only ever sent to the API when they are well-formed UUIDs. */
export const isUuid = (value: string | null | undefined): value is string =>
  typeof value === 'string' && UUID.test(value);
